<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
    v-model="dialog"
    :width="$vuetify.breakpoint.mdAndUp ? '800px' : '600px'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="primary" v-bind="attrs" @click="initialize" v-on="on">
        {{ $t('cap_form_create_menu') }}
      </v-btn>
    </template>
    <v-card>
        <CassNewCreateMenu></CassNewCreateMenu>
        <CassViewMenu :locale="locale"></CassViewMenu>
    </v-card>
  </v-dialog>
</template>

<script>
import CassNewCreateMenu from './CassNewCreateMenu'
import CassViewMenu from '../cards/CassViewMenu'
export default {
  components: { CassViewMenu, CassNewCreateMenu },
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data: () => ({
    dialog: false,
    menus: [],
    cateRule: [
      v => !!v || 'Text is required!',
      // v => v.length <= 20 || 'Menu must be less than 20 words',
    ],
    cateRuleLan: [
      // v => v.length <= 20 || 'Menu must be less than 20 words',
    ]

  }),

  methods: {
    initialize() {
      this.dialog = true
      this.menus = this.$store.state.tenant.menus
    }
  }
}
</script>
